var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.panelistAlternativesSelector
        ? _c(
            "PanelistAlternativesSelector",
            _vm._b(
              {
                on: {
                  confirm: _vm.handleUpdatePanelistAlternativesCommand,
                  close: _vm.closePanelistAlternativesSelector,
                },
              },
              "PanelistAlternativesSelector",
              _vm.panelistAlternativesSelector,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.panelistsSelector
        ? _c(
            "PanelistsSelector",
            _vm._b(
              {
                on: {
                  showPanelistAlternativesSelector:
                    _vm.showPanelistAlternativesSelector,
                  includePanelist: _vm.handleIncludePanelistCommand,
                  excludePanelist: _vm.handleExcludePanelistCommand,
                  close: _vm.closePanelistsSelector,
                },
              },
              "PanelistsSelector",
              _vm.panelistsSelector,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c("EmailSender", {
        attrs: { viewModel: _vm.emailSender },
        on: { "form-submit": _vm.handleSendEmailCommand },
      }),
      _vm._v(" "),
      _c("SurveyAccessLinks", {
        attrs: { viewModel: _vm.surveyAccessLinks },
        on: {
          "send-email": _vm.handleSendEmailCommand,
          "download-links": _vm.downloadLinks,
        },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.Initialized
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: _vm.url_AssessmentsPanelsPage,
                            expression: "url_AssessmentsPanelsPage",
                          },
                        ],
                        staticClass: "text-dark",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back to panels\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Panelists: " +
                          _vm._s(_vm.SurveyName) +
                          " (" +
                          _vm._s(_vm.Progress) +
                          "%)\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v("Targeting: " + _vm._s(_vm.TargetingLabel)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6 text-right mt-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: { role: "button" },
                      on: { click: _vm.showAccessLinks },
                    },
                    [_vm._v("Access links")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: {
                        role: "button",
                        disabled: !_vm.EnabledAddingPanelists,
                      },
                      on: { click: _vm.showPanelistsSelector },
                    },
                    [_vm._v("Add panelists")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        !_vm.Initialized
          ? _c("h3", [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Loading... "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.Initialized
          ? _c("div", [
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md bg-light",
                  attrs: { role: "navigation" },
                },
                [
                  _c("form", { staticClass: "form-inline mr-2" }, [
                    _c("div", { staticClass: "btn-group" }, [
                      _vm.NonePanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.SelectAllCommand },
                            },
                            [_c("i", { staticClass: "fa-regular fa-square" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.AnyPanelistsSelected && !_vm.AllPanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.UnselectAllCommand },
                            },
                            [_c("i", { staticClass: "fa fa-minus-square" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.AllPanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.UnselectAllCommand },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-square-check",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("button", {
                        staticClass:
                          "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.SelectAllCommand },
                          },
                          [_vm._v("All")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.UnselectAllCommand },
                          },
                          [_vm._v("None")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.InverseSelectionCommand },
                          },
                          [_vm._v("Inverse")]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline mr-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm",
                        class: [
                          _vm.NonePanelistsSelected
                            ? "btn-outline-secondary"
                            : "btn-outline-primary",
                        ],
                        attrs: {
                          type: "button",
                          disabled: _vm.NonePanelistsSelected,
                        },
                        on: { click: _vm.EmailManyCommand },
                      },
                      [
                        _vm._v(
                          "\n                        Send email (" +
                            _vm._s(_vm.SelectedPanelistsCount) +
                            ")\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline my-2 my-lg-0 mr-2" }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _vm._v("\n                        Filter: "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-primary font-weight-bold dropdown-toggle",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [_vm._v(_vm._s(_vm.FilterLabel))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu dropdown-menu-right" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.resetFilters()
                                },
                              },
                            },
                            [_c("span", [_vm._v("All panelists")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By progress:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("Not started")
                                },
                              },
                            },
                            [_c("span", [_vm._v("Not started")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("In progress")
                                },
                              },
                            },
                            [_c("span", [_vm._v("In progress")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("Completed")
                                },
                              },
                            },
                            [_c("span", [_vm._v("Completed")])]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By tag:"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.tags, function (t) {
                            return _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.filterByTag(t)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(t))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.SearchPhrase,
                            expression: "SearchPhrase",
                          },
                        ],
                        staticClass: "form-control form-control-sm mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.SearchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.SearchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("table", { staticClass: "table table-hover" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.PanelistsView, function (p) {
                        return _c("tr", { key: p.ProjectUserId }, [
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "40px" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: p.IsSelected,
                                    expression: "p.IsSelected",
                                  },
                                ],
                                staticStyle: { width: "20px", height: "20px" },
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(p.IsSelected)
                                    ? _vm._i(p.IsSelected, null) > -1
                                    : p.IsSelected,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = p.IsSelected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            p,
                                            "IsSelected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            p,
                                            "IsSelected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(p, "IsSelected", $$c)
                                    }
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "p",
                              { staticClass: "fg-color-gray mb-0 mt-1" },
                              [_c("span", [_vm._v(_vm._s(p.Name))])]
                            ),
                            _vm._v(" "),
                            p.HasEmail
                              ? _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(p.Email)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !p.HasEmail
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v("Email not provided"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "align-middle" }, [
                            _c(
                              "div",
                              {
                                staticClass: "progress",
                                staticStyle: { margin: "0" },
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "progress-bar progress-bar-success progress-bar-striped",
                                  style: {
                                    width: _vm.getProgressStr(p.Progress),
                                  },
                                  attrs: {
                                    title: _vm.getProgressStr(p.Progress),
                                    role: "progressbar",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.TargetingEnabled
                            ? _c("td", { staticClass: "align-middle" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPanelistAlternativesSelector(
                                          p.ProjectUserId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(p.AlternativesCount) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "120px" },
                            },
                            [
                              _c("div", { staticClass: "dropdown" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Actions\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/est/dashboard/${_vm.workspaceId}/${_vm.surveyId}/${p.ProjectUserId}`,
                                            expression:
                                              "`/#/est/dashboard/${workspaceId}/${surveyId}/${p.ProjectUserId}`",
                                          },
                                        ],
                                        staticClass: "dropdown-item",
                                        attrs: { target: "_blank" },
                                      },
                                      [_vm._v("Review")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.EmailOneCommand(
                                              p.ProjectUserId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Email")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    !_vm.TargetingEnabled
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleExcludePanelistCommand(
                                                  p.ProjectUserId
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Exclude")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.TargetingEnabled
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showPanelistAlternativesSelector(
                                                  p.ProjectUserId
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Targeting")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }